import type { Variants } from "motion/react";

export const MODAL_OPEN_S = 0.28;
export const MODAL_CLOSE_S = 0.22;

export const MODAL_EASE = [0.22, 1, 0.36, 1] as const;

/**
 * Shell open/close for Modal. Scale lives on an inner panel so it does
 * not share a transform with the static centering translate.
 */
export function modalOverlayMotion(reduceMotion: boolean): Variants {
  if (reduceMotion) {
    return {
      initial: { opacity: 0 },
      animate: { opacity: 1, transition: { duration: 0 } },
      exit: { opacity: 0, transition: { duration: 0 } },
    };
  }

  return {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: MODAL_OPEN_S, ease: MODAL_EASE } },
    exit: { opacity: 0, transition: { duration: MODAL_CLOSE_S, ease: MODAL_EASE } },
  };
}

export function modalPanelMotion(reduceMotion: boolean): Variants {
  if (reduceMotion) {
    return {
      initial: { opacity: 0 },
      animate: { opacity: 1, transition: { duration: 0 } },
      exit: { opacity: 0, transition: { duration: 0 } },
    };
  }

  return {
    initial: { opacity: 0, scaleX: 0.78, scaleY: 0.06 },
    animate: {
      opacity: 1,
      scaleX: 1,
      scaleY: 1,
      transition: { duration: MODAL_OPEN_S, ease: MODAL_EASE },
    },
    exit: {
      opacity: 0,
      scaleX: 0.78,
      scaleY: 0.06,
      transition: { duration: MODAL_CLOSE_S, ease: MODAL_EASE },
    },
  };
}
